import { VisibilityElement } from './visibility'
import { ModalElement } from './modal'
import { InViewElement } from './in-view'
import { ReadMore } from './read-more'
import { StickyHeader } from './sticky-header'
import { MiniCart } from './mini-cart'
import { ProductForm } from './product-form'
import { VariantSelector } from './variant-selector'
import { EnhancedProductForm } from './enhanced-product-form'
import { QuantityInput } from './quantity-input'
import { Carousel } from './carousel'
import { StickyProductForm } from './sticky-product-form'
import 'snippets/notice-global/notice-global'
import { CustomForm } from '@/components/custom-elements/custom-form'
import { LightBoxElement } from '@/components/custom-elements/lightbox'
import 'snippets/navigation/localization-form'
import register from 'preact-custom-element'
import { ListDisplayElement } from '@/components/custom-elements/list-display'
import { ButtonElement } from './button'
import { CountdownElement } from './countdown'
import { GiftCardForm } from './gift-card-form'
import { KlaviyoStarRatingElement } from './klaviyo-star-rating'
import { MarqueeElement } from './marquee'
import { TabbedContent } from './tabbed-content'
import { UniversalSizeSelector } from './universal-size-selector'
import { NavAnchor } from './nav-anchor'

register(MiniCart, 'mini-cart', ['acceleratedCheckout'])
customElements.define('x-visibility', VisibilityElement)
customElements.define('x-lightbox', LightBoxElement)
customElements.define('x-modal', ModalElement)
customElements.define('x-in-view', InViewElement)
customElements.define('x-quantity-input', QuantityInput)
customElements.define('sticky-header', StickyHeader)
customElements.define('read-more', ReadMore)
customElements.define('product-form', ProductForm)
customElements.define('variant-selector', VariantSelector)
customElements.define('x-list-display', ListDisplayElement)
customElements.define('x-custom-form', CustomForm)
customElements.define('enhanced-product-form', EnhancedProductForm)
customElements.define('x-carousel', Carousel)
customElements.define('sticky-product-form', StickyProductForm)
customElements.define('x-button', ButtonElement)
customElements.define('x-countdown', CountdownElement)
customElements.define('gift-card-form', GiftCardForm)
customElements.define('klaviyo-star-rating', KlaviyoStarRatingElement)
customElements.define('x-marquee', MarqueeElement)
customElements.define('x-tabbed-content', TabbedContent)
customElements.define('universal-size-selector', UniversalSizeSelector)
customElements.define('nav-anchor', NavAnchor)
